import { Component, OnInit } from '@angular/core';
import { ModalController, ToastController, AlertController } from '@ionic/angular';
import { MagirusPositionGroupService } from 'src/app/data/service/magirus-position-group.service';

@Component({
  selector: 'app-position-groups-manager',
  templateUrl: './position-groups-manager.component.html',
  styleUrls: ['./position-groups-manager.component.scss'],
})
export class PositionGroupsManagerComponent implements OnInit {
  groups: any[] = [];
  editingGroupId: number | null = null;
  editingName: string = '';
  newGroupName: string = '';
  isAddingNew: boolean = false;

  constructor(
    private modalCtrl: ModalController,
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
    private positionGroupService: MagirusPositionGroupService
  ) {}

  ngOnInit() {
    this.loadGroups();
  }

  loadGroups() {
    this.positionGroupService.getAllPositionGroups().subscribe({
      next: (groups) => {
        this.groups = groups;
      },
      error: (error) => {
        console.error('Error loading position groups:', error);
      }
    });
  }

  startEdit(group: any) {
    this.editingGroupId = group.id;
    this.editingName = group.name;
  }

  cancelEdit() {
    this.editingGroupId = null;
    this.editingName = '';
  }

  saveEdit(group: any) {
    if (this.editingName.trim()) {
      this.positionGroupService.renamePositionGroup(group.id, this.editingName.trim()).subscribe({
        next: () => {
          group.name = this.editingName.trim();
          this.editingGroupId = null;
          this.editingName = '';
          this.showToast('Gruppe umbenannt');
        },
        error: (error) => {
          console.error('Error renaming group:', error);
          this.showToast('Fehler beim Umbenennen', 'danger');
        }
      });
    }
  }

  async confirmDelete(group: any) {
    const alert = await this.alertCtrl.create({
      header: 'Löschen bestätigen',
      message: `Gruppe "${group.name}" wirklich löschen?`,
      buttons: [
        { text: 'Abbrechen', role: 'cancel' },
        { 
          text: 'Löschen', 
          role: 'destructive', 
          handler: () => this.deleteGroup(group)
        }
      ]
    });
    await alert.present();
  }

  deleteGroup(group: any) {
    this.positionGroupService.deletePositionGroup(group.id).subscribe({
      next: () => {
        this.groups = this.groups.filter(g => g.id !== group.id);
        this.showToast('Gruppe gelöscht');
      },
      error: (error) => {
        console.error('Error deleting group:', error);
        this.showToast('Fehler beim Löschen', 'danger');
      }
    });
  }

  startAddNew() {
    this.isAddingNew = true;
    this.newGroupName = '';
  }

  cancelAddNew() {
    this.isAddingNew = false;
    this.newGroupName = '';
  }

  saveNewGroup() {
    if (this.newGroupName.trim()) {
      this.positionGroupService.createPositionGroup({ name: this.newGroupName.trim() }).subscribe({
        next: (newGroup) => {
          this.groups.push(newGroup);
          this.isAddingNew = false;
          this.newGroupName = '';
          this.showToast('Gruppe erstellt');
        },
        error: (error) => {
          console.error('Error creating group:', error);
          this.showToast('Fehler beim Erstellen', 'danger');
        }
      });
    }
  }

  private async showToast(message: string, color: string = 'primary') {
    const toast = await this.toastCtrl.create({
      message,
      duration: 2000,
      color
    });
    await toast.present();
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
